import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { useQuizResults } from '@mentimeter/quiz';
import type { QuizPlayersScoreData } from '@mentimeter/core-hooks';
import { useLeaderboardResults } from './useLeaderboardResults';
import { ViewOnlyPresentation } from './ViewOnlyPresentation';

export const ViewOnlyPresentationDataHandler = ({
  timeBasedScoring,
}: {
  timeBasedScoring: boolean;
}) => {
  const { useQuestion, useConfig, InteractiveCanvasComponents } =
    usePresentationContext();
  const {
    question,
    title_meta,
    question_description,
    question_styled,
    layout,
    id,
  } = useQuestion();
  const { enableAnimations } = useConfig();
  const { data: quizResults } = useQuizResults<QuizPlayersScoreData>();
  const leaderboardResults = useLeaderboardResults(quizResults);

  return (
    <ViewOnlyPresentation
      question={question}
      question_styled={question_styled}
      title_meta={title_meta}
      question_description={question_description}
      id={id}
      layout={layout}
      shouldAnimate={enableAnimations}
      leaderboardResults={leaderboardResults}
      timeBasedScoring={timeBasedScoring}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
    />
  );
};
